import { HtmlRenderer, Parser } from 'commonmark'

import * as React from 'react';
import { Link } from 'react-router';
import { commonStingManagerManager } from '../../api/commonStingManagerManager';

import { WithRouterProps } from 'react-router';

import NewsCategory from '../../api/newsCategoryEntity';
import NewsItem from '../../api/newsItemEntity';
import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';
import { WelcomePageNewsBlockContainer } from '../welcomePageNewsBlock/welcomePageNewsBlockContainer';

interface IProps extends WithRouterProps {
    newsItemId: string;
    newsItem: NewsItem;
    fetchNewsItemById(id: string): void;
}

export class NewsPage extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchNewsItemById(this.props.newsItemId);
  }

  public componentWillReceiveProps (nextProps: IProps) {
    if(nextProps.newsItemId !== this.props.newsItemId) {
      // Clean component and reload
      this.props.fetchNewsItemById(nextProps.newsItemId);
    }
 }

  public render() {
    const parser = new Parser()
    const renderer = new HtmlRenderer()
    const content = renderer.render(parser.parse(this.props.newsItem.body))

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="content">
                            <h1>{this.props.newsItem.title}</h1>
                            <span className="date">{commonStingManagerManager.formatDateToFiCulture(this.props.newsItem.publicationDate)}</span>
                            <img src={this.props.newsItem.newsImage} className="align-right" />
                            <p dangerouslySetInnerHTML={ {__html: content} } />

                            <b>Asiasanat:</b>
                            <ul id="taglist">
                                {this.props.newsItem.categories && this.props.newsItem.categories.map(NewsCategoryItem)}
                            </ul>
                            <br />

                            <Link to={`/ajankohtaista`} className="back">Kaikki ajankohtaiset</Link>

                            <div className="news-row">
                                <WelcomePageNewsBlockContainer />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
  }
};

const NewsCategoryItem = (newsCategory: NewsCategory) => {
    return (
      <li>
        <Link to={`/uutiset/ajankohtaista${newsCategory.friendlyUrl}`}>{newsCategory.title}</Link>
      </li>
    )
  }


// WEBPACK FOOTER //
// ./src/components/newsPage/newsPage.tsx